"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Fuel, Users, Gauge } from "lucide-react";
const wp_query_params = {
  per_page: 3,
  post_type: "product",
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
function FeaturedFleetConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse rounded-xl bg-muted/10" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-destructive">
        <p>Unable to load fleet selection. Please try again later.</p>
      </div>;
  }
  if (products.length === 0) {
    return <div className="text-center text-muted-foreground">
        <p>No vehicles currently available in this selection.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="group overflow-hidden border-border/50 bg-card transition-colors hover:border-primary/50">
          {}
          <div className="relative aspect-[16/10] overflow-hidden bg-muted">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-secondary text-muted-foreground">
                No Image Available
              </div>}
            {}
          </div>

          <CardHeader className="pb-2">
            <CardTitle className="text-xl font-bold tracking-tight text-card-foreground">
              {product.title}
            </CardTitle>
          </CardHeader>

          <CardContent className="space-y-4">
            {}
            <div className="flex flex-wrap gap-2">
              {}
              {product.customFields?.transmission ? <Badge variant="secondary" className="gap-1.5">
                  <Gauge className="size-3.5" />
                  {product.customFields.transmission}
                </Badge> : <Badge variant="secondary" className="gap-1.5">
                  <Gauge className="size-3.5" />
                  Automatic
                </Badge>}

              {product.customFields?.seats ? <Badge variant="secondary" className="gap-1.5">
                  <Users className="size-3.5" />
                  {product.customFields.seats} Seats
                </Badge> : <Badge variant="secondary" className="gap-1.5">
                  <Users className="size-3.5" />5 Seats
                </Badge>}

              {product.customFields?.fuel ? <Badge variant="secondary" className="gap-1.5">
                  <Fuel className="size-3.5" />
                  {product.customFields.fuel}
                </Badge> : <Badge variant="secondary" className="gap-1.5">
                  <Fuel className="size-3.5" />
                  Petrol
                </Badge>}
            </div>

            {}
            {product.short_description && <div className="line-clamp-2 text-sm text-muted-foreground" dangerouslySetInnerHTML={{
          __html: product.short_description
        }} />}
            
            {}
             <div className="text-lg font-semibold text-primary">
                £{product.price || product.customFields?.price || "0.00"} <span className="text-sm font-normal text-muted-foreground">/ day</span>
             </div>
          </CardContent>

          <CardFooter className="pt-0">
            <Link to={product.link} className="w-full">
              <Button className="w-full cursor-pointer" size="lg">
                View Details
              </Button>
            </Link>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function FeaturedFleetSelection() {
  return <section id="featured-fleet-selection" className="dark bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
            Featured Fleet Selection
          </h2>
          <p className="mx-auto mt-4 max-w-[700px] text-muted-foreground md:text-lg">
            Experience the perfect blend of performance and comfort with our
            premium vehicle collection.
          </p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 3,
        post_type: "product",
        orderby: "date",
        order: "desc"
      }} className="w-full">
          <FeaturedFleetConsumer />
        </EcommerceProductsProvider>

        <div className="mt-12 text-center">
          <Link to="#">
            <Button variant="outline" size="lg" className="min-w-[200px]">
              View All Vehicles
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}